
export const validateReperto = (data) => {
  let issues = [];
  if(!Array.isArray(data.groups) || data.groups.length === 0) issues.push("Il reperto deve essere associato ad almeno un gruppo di lavoro");
  return issues;
}

